import { IConfig } from '@cian/config/shared';

export const isMessageBubblesEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.MessageBubbles.Enabled'));
};
